import { CommonModule, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../custom-landing/custom-landing.module';
import { I18nModule, TranslationService } from '@spartacus/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/core/services/toaster.service';

@Component({
    selector: 'app-commonconfirmpopup',
    templateUrl: './commonconfirmpopup.component.html',
    styleUrl: './commonconfirmpopup.component.scss',
    imports: [NgIf, I18nModule]
})
export class CommonconfirmpopupComponent {
  @Input() from:string;
  constructor(public ActiveModal: NgbActiveModal,
    public toastrService: ToastService,translation: TranslationService){

  }
  closeModal() {
    this.ActiveModal.close('No');
  }
  YesClicked(){
    this.ActiveModal.close('Yes');
  }

}
